import ProductCard from "./ProductCard";

export default function ProductCharacteristics(props){

    /*const data = []
        {
            title: PanelesEnum.OUR_SOLUTION_1_TITLE,
            description: PanelesEnum.OUR_SOLUTION_1_DESC,
            imgLink: [char0]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_8_TITLE,
            description: PanelesEnum.OUR_SOLUTION_8_DESC,
            imgLink: [char7,char8,char9]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_2_TITLE,
            description: PanelesEnum.OUR_SOLUTION_2_DESC,
            imgLink: [char1]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_3_TITLE,
            description: PanelesEnum.OUR_SOLUTION_3_DESC,
            imgLink: [char2]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_4_TITLE,
            description: PanelesEnum.OUR_SOLUTION_4_DESC,
            imgLink: [char3]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_5_TITLE,
            description: PanelesEnum.OUR_SOLUTION_5_DESC,
            imgLink: [char4]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_6_TITLE,
            description: PanelesEnum.OUR_SOLUTION_6_DESC,
            imgLink: [char5]
        },
        {
            title: PanelesEnum.OUR_SOLUTION_7_TITLE,
            description: PanelesEnum.OUR_SOLUTION_7_DESC,
            imgLink: [char6]
        },
    ]*/

    return(
        <div id="characteristics" className="bg-white">
            {
                props.data.map(function(serviceIndex, serviceValue){
                    //Se debe hacer una card que interscale la screenshot a la derecha o
                    //izquierda y que contenga titulo y descripcion
                    //Además se debe hacer una animacion a la hora de mostrar la card
                    //que vaya apareciendo desde abajo hacia arriba cada vez que "entra"
                    //en la pantalla
                    return(
                    <>
                        <ProductCard isEven={serviceValue % 2 === 0}
                                     title={serviceIndex.title}
                                     description={serviceIndex.description}
                                     imgLink={serviceIndex.imgLink}
                                     index={serviceValue}
                                     isLargeScreen={props.isLargeScreen}
                                     key={"paneles-characteristics-" + serviceValue}/>
                    </>
                    )
                })
            }
        </div>
    );
}